export default [
  {
    path: "/app/legal-notice",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Informe Legais",
      requiresAuth: true,
    },
    children: [
      {
        path: "sagres",
        name: "legal-notice.sagres",
        component: () => import("../sagres/index.vue"),
        meta: {
          permission: "view_sagres",
        },
      },
      {
        path: "educacenso/import",
        name: "legal-notice.educacenso.import",
        component: () => import("../educacenso/import/views/List.vue"),
      },
      {
        path: "educacenso/import/create",
        name: "legal-notice.educacenso.import.create",
        component: () => import("../educacenso/import/views/Create.vue"),
      },
      {
        path: "educacenso/export",
        name: "legal-notice.educacenso.export",
        component: () => import("../educacenso/export/views/Index.vue"),
      },
    ],
  },
];
